<script>
  import Links from './Links.svelte';
  import Standings from './Standings.svelte';
  import MarkdownBox from '../MarkdownBox.svelte';

  export let value;
  export let lang = undefined;

  const i18n = {
    group: {
      cs: 'Skupina',
      en: 'Group',
    },
    founded: {
      cs: 'Založeno',
      en: 'Founded',
    },
  };
</script>

<div class='overview'>
  <div class='overview-name'>
    {value.name[lang]}
  </div>

  {#if value.group || value.founded}
    <div class='overview-basic-info'>
      {#if value.group}
        <div class='overview-basic-info-group'>
          {i18n.group[lang]} <b> {value.group.toUpperCase()} </b>
        </div>
      {/if}

      {#if value.founded}
        <div class='overview-basic-info-founded'>
          {i18n.founded[lang]} <b> {value.founded} </b>
        </div>
      {/if}
    </div>
  {/if}

  <div class='overview-content'>
    <div class='overview-content-links-and-standings'>
      <div class='overview-content-links-and-standings-links'>
        <Links value={value}/>
      </div>

      <div class='overview-content-links-and-standings-standings'>
        <Standings value={value} bind:lang/>
      </div>
    </div>

    {#if value.content[lang]}
      <div class='overview-content-value'>
        <MarkdownBox value={value.content[lang]}/>
      </div>
    {/if}
  </div>
</div>

<style>
  .overview {
    display: flex;
    flex-direction: column;
    gap: 40px;

    width: 100%;
    height: 100%;
  }

  .overview-name {
    font-family: var(--font-secondary);
    font-size: 64px;
    font-weight: bold;
  }

  .overview-basic-info {
    display: flex;
    justify-content: space-between;
    gap: 20px;

    width: 100%;
  }

  .overview-basic-info-founded, .overview-basic-info-group {
    width: calc((100% - 20px) / 2);
  }

  .overview-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .overview-content-links-and-standings {
    display: flex;
    justify-content: space-between;
    gap: 20px;

    width: 100%;
  }

  .overview-content-links-and-standings-links, .overview-content-links-and-standings-standings {
    width: calc((100% - 20px) / 2);
  }

  @media only screen and (max-width: 1250px) {
    .overview-content-links-and-standings {
      flex-direction: column;
    }

    .overview-content-links-and-standings-links, .overview-content-links-and-standings-standings {
      width: 100%;
    }
  }

  @media only screen and (max-width: 1050px) {
    .overview-content-links-and-standings {
      flex-direction: row;
    }

    .overview-content-links-and-standings-links, .overview-content-links-and-standings-standings {
      width: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 850px) {
    .overview-content-links-and-standings {
      flex-direction: column;
    }

    .overview-content-links-and-standings-links, .overview-content-links-and-standings-standings {
      width: 100%;
    }
  }

  @media only screen and (max-width: 550px) {
    .overview-name {
      font-size: 48px;
    }

    .overview-basic-info {
      flex-direction: column;
    }

    .overview-basic-info-group, .overview-basic-info-founded {
      width: 100%;
    }
  }

  @media only screen and (max-width: 450px) {
    .overview-name {
      font-size: 40px;
    }
  }
</style>
